import { ServerEvent } from "@/Common/Stores/Actions/ServerEvent";

class AttachedDocumentDetail {
    public FileName: string;
    public ReceiptDate: string;
    public FullPath: string;
    public DocumentId: string;
    public DocumentBytesId: string;

    public static FromResponse(response: ServerEvent): AttachedDocumentDetail[] {
        var results = [];

        var items: AttachedDocumentDetail[] = response.Data["AttachedDocumentDetails"];
        items.forEach(item => {
            var tmpDoc = new AttachedDocumentDetail();

            tmpDoc.FileName = item.FileName;
            tmpDoc.ReceiptDate = item.ReceiptDate;
            tmpDoc.FullPath = item.FullPath;
            tmpDoc.DocumentId = item.DocumentId;
            tmpDoc.DocumentBytesId = item.DocumentBytesId;

            results.push(tmpDoc);
        });

        return results;
    }

    public static fromResponseV2(response: { AttachedDocumentDetails: AttachedDocumentDetail[] }): AttachedDocumentDetail[] {
        var results = [];

        var items: AttachedDocumentDetail[] = response.AttachedDocumentDetails;
        items.forEach(item => {
            var tmpDoc = new AttachedDocumentDetail();

            tmpDoc.FileName = item.FileName;
            tmpDoc.ReceiptDate = item.ReceiptDate;
            tmpDoc.FullPath = item.FullPath;
            tmpDoc.DocumentId = item.DocumentId;
            tmpDoc.DocumentBytesId = item.DocumentBytesId;

            results.push(tmpDoc);
        });

        return results;
    }
}

export { AttachedDocumentDetail };
